import { css, jsx } from '@emotion/core';
import { Col, Input, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState }from 'react';
import { useRouter } from 'next/router';
import Form from '@/src/shared/components/Form';
import PhoneInput from '@/src/shared/components/PhoneInput';
import ReCaptchaFormItem from '@/src/shared/components/ReCaptchaFormItem';
import { colMdProps, rowProps } from '@/utils/rowColHelpers';
import request from '@/utils/axios';

const { TextArea } = Input;

const style = {
  text: css`
    font-size: 1.6rem;
    margin-bottom: 0px;
  `,
  subjectLabel: css`
    label {
      margin-bottom: 0px !important;
    }
  `,
};

const FormFields = props => {
  const { form } = props;

   const router = useRouter();
   const {
     query: { typecode = null },
   } = router;
  
  const [selectedTypeCode, setSelectedTypeCode] = useState('T');
  const [selectedSubject, setSelectedSubject] = useState('Technical Question / Comment');

   
  useEffect(() => {
    const fetchTypes = async () => {
      if (!typecode) return;

      try {
        const response = await request({
          method: 'GET',
          url: '/askus/types',
          triggerLoad: false,
        });

        const types = response?.data;
        if (!Array.isArray(types)) return;

        const match = types.find(item => item.TypeCode === typecode);
        if (match) {
          setSelectedSubject(match.TypeDescription || 'Technical Question / Comment');
          setSelectedTypeCode(match.TypeCode);
          form.setFieldsValue({ TypeCode: match.TypeCode });
        }
      } catch (err) {
        console.error('Error fetching /askus/types', err);
      }
    };

    fetchTypes();
  }, [typecode]);


  const renderInput = ({ label, decorator, formProps = {} }) => {
    return (
      <Form.Item label={label}>
        {form.getFieldDecorator(decorator, {
          ...formProps,
        })(<Input allowClear size="large" />)}
      </Form.Item>
    );
  };

  const validateFirstEmail = (rule, value, callback) => {
    const confirmEmailAddress = form.getFieldValue('ConfirmEmail');
    if (value === confirmEmailAddress) {
      form.validateFields(['ConfirmEmail'], { force: true });
      callback();
    } else {
      callback('Emails must be consistent.');
    }
  };

  const validateConfirmEmail = (rule, value, callback) => {
    const emailAddress = form.getFieldValue('EmailAddress');
    if (value === emailAddress) {
      form.validateFields(['EmailAddress'], { force: true });
      callback();
    } else {
      callback('Emails must be consistent.');
    }
  };

  return (
    <>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          {renderInput({
            label: 'Name',
            decorator: 'Name',
            formProps: { rules: [{ required: true, message: 'Enter Name.' }] },
          })}
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          {renderInput({
            label: 'Company',
            decorator: 'Company',
            formProps: { rules: [{ required: true, message: 'Enter Company.' }] },
          })}
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="Phone">
            {form.getFieldDecorator('Phone', {})(<PhoneInput mask="999-999-9999" size="large" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="Email Address" hasFeedback>
            {form.getFieldDecorator('EmailAddress', {
              rules: [
                { required: true, message: 'Enter Email Address.' },
                { type: 'email', message: 'Email is not valid.' },
              ],
            })(<Input type="email" allowClear size="large" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="Confirm Email Address" hasFeedback>
            {form.getFieldDecorator('ConfirmEmail', {
              rules: [
                { required: true, message: 'Confirm Email Address.' },
                { type: 'email', message: 'Email is not valid.' },
                { validator: validateConfirmEmail },
              ],
            })(<Input allowClear size="large" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label='Subject' css={style.subjectLabel}>
            {form.getFieldDecorator('TypeCode', {
              initialValue: selectedTypeCode,
            })(<p css={style.text}>{selectedSubject}</p>)}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          {renderInput({
            label: 'Regarding',
            decorator: 'Subject',
            formProps: { rules: [{ required: true, message: 'Enter Regarding.' }] },
          })}
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="Question/Comment">
            {form.getFieldDecorator('CommentQuestion', {
              rules: [{ required: true, message: 'Enter Question/Comment.' }],
            })(<TextArea rows={4} allowClear />)}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="">
            {form.getFieldDecorator('ReCaptcha', {
              rules: [{ required: true, message: 'Check, checkbox.' }],
            })(<ReCaptchaFormItem />)}
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

FormFields.propTypes = {};

export default FormFields;
